module.exports = __webpack_public_path__ + "img/logo-prod.de7a3370.png";